<script>
import Cookies from "js-cookie";
import {notificationMethods, educationMethods, uploadMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import api from '../../../helpers/axios'

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Educations",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      selectedSite: "",
      sites: [],
      courses: [],
      level: [],
      educations: [],
      selectedCourses: [],
      currentUser: JSON.parse(Cookies.get('user')),
      title: "Eğitimler Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Eğitimler",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {
        name: null,
        title: null,
        level: [],
        site: [],
        image: null,
        isActive: true
      },
      editForm: {
        name: null,
        title: null,
        level: [],
        site: [],
        image: null,
        isActive: true
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: 'Eğitim Adı',
          sortable: true,
        }, {
          key: "title",
          label: 'Eğitim Başlık',
          sortable: true,
        },
        {
          key: "site",
          label: 'Site',
          sortable: true,
        },
        {
          key: "level",
          label: 'Kurlar',
          sortable: true,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      name: {required},
      title: {required},
      site: {required},
      level: {required},
      image: {required},
    },
    editForm: {
      name: {required},
      title: {required},
      site: {required},
      level: {required},
      image: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getEducations(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getEducations();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    },
    'editForm.email': function () {
      this.editForm.email = this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
    this.getEducations();
    this.fetchSites();
    this.fetchLevels();
  },
  methods: {
    ...educationMethods,
    ...notificationMethods,
    ...uploadMethods,
    resetForm(){
      this.addForm = {
        name: null,
        title: null,
        level: [],
        site: [],
        image: null,
        isActive: null,
      };
      this.editForm = {
        name: null,
        title: null,
        level: [],
        site: [],
        image: null,
        isActive: null,
      };
      this.addSubmitted = false;
      this.editSubmitted = false;
    },
    onImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;

      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'educations')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.image = res.url;
        this.imgLoading = false;
      })
    },
    onEditImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'educations')
      let editForm = this.editForm;
      this.editImgLoading = true;

      this.uploadFile(data).then((res) => {
        editForm.image = res.url;
        this.editImgLoading = false;
      })
    },
    toggleLevelSelection(levelId) {
      if (this.addForm.level.includes(levelId)) {
        this.addForm.level = this.addForm.level.filter(id => id !== levelId);
      } else {
        this.addForm.level.push(levelId);
      }
    },
    formatSite(site) {
      return site
    },
    doSearch() {
      if (this.page === 1) {
        this.getEducations();
      } else {
        this.page = 1;
      }
    },
    getEducations(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchEducations({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        if (res.docs && Array.isArray(res.docs)) {
          this.items = res.docs.map(elem => {
            if (elem.level && Array.isArray(elem.level)) {
              return {
                ...elem,
                level: elem.level.map(level => {
                  return {
                    id: level._id,
                    name: level.name,
                  };
                }),
              };
            } else {
              return {
                ...elem,
                level: [],
              };
            }
          });
        } else {
          return
        }
        this.itemsLoaded = true;
      })
    },
    async fetchSites() {
      try {
        const response = await api.get("/sites");
        this.sites = response.data.data.docs;
      } catch (error) {
        return;
      }
    },


    async fetchLevels() {
      try {
        const response = await api.get("/levels?limit=100");
        this.level = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    async handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();
      if (this.$v.addForm.$invalid) {
        return;
      } else if (!this.addForm.site.length) {
        this.formError = "Site seçilmesi gereken bir alandır.";
        return;
      } else {
        const postData = {
          name: this.addForm.name,
          title: this.addForm.title,
          site: this.addForm.site,
          level: this.addForm.level,
          image: this.addForm.image,
        };
        this.createEducation(postData)
            .then(() => {
              this.toastMessage = "Eğitim başarıyla eklendi!";
              this.toastAction = "success";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
              this.addForm.name = "";
              this.addForm.title = "";
              this.addForm.site = [];
              this.addForm.level = [];
              this.addForm.image = "";
              this.showModal = false;
              this.getEducations();
            })
            .catch((err) => {
              if (err == "TCNUMBER_ALREADY_USE") {
                this.formError = "Girilen TC numarasına sahip bir Eğitim bulunmaktadır.";
              } else {
                this.toastMessage = "Sistemde bir hata oluştu!";
                this.toastAction = "error";
                this.showToast = true;
                setTimeout(() => {
                  this.showToast = false;
                }, 3000);
              }
            });
      }
    },
    async handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = "";
      this.$v.editForm.$touch();
      if (this.$v.editForm.$invalid) {
        return;
      } else {
        const editData = {
          id: this.editId,
          data: {
            name: this.editForm.name,
            title: this.editForm.title,
            site: this.editForm.site,
            level: this.editForm.level,
            image: this.editForm.image,
          },
        };
        this.updateEducation(editData)
            .then(() => {
              this.toastMessage = "Eğitim başarıyla düzenlendi!";
              this.toastAction = "success";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
              this.editModal = false;
              this.getEducations();
              this.editForm.name = "";
              this.editForm.site = [];
              this.editForm.level = [];
            })
            .catch((err) => {
              if (err == "TCNUMBER_ALREADY_USE") {
                this.editFormError = "Girilen TC numarasına sahip bir Eğitim bulunmaktadır.";
              } else {
                this.toastMessage = "Sistemde bir hata oluştu!";
                this.toastAction = "error";
                this.showToast = true;
                setTimeout(() => {
                  this.showToast = false;
                }, 3000);
              }
            });
      }
    },
    handleDeleteSubmit() {
      this.deleteEducation(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Eğitim başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getEducations();
      })
    },
    openEdit(education) {
      this.editForm.name = education.name;
      this.editForm.title = education.title;
      this.editForm.image = education.image;
      this.editForm.site = education.site.map(site => site._id);
      this.editForm.level = education.level.map((level) => level.id);
      this.editId = education.id;
      this.editModal = true;
    },
    openDelete(education) {
      if (education.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = education.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Eğitim Ekle
                </button>
              </div>
            </div>
            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{ new Date(data.item.createdAt).toDateString() }}
                  </template>

                  <template>
                    <div>
                      <ul>
                        <li v-for="education in educations" :key="education.id">{{ education.name }}</li>
                      </ul>
                    </div>
                  </template>
                  <template v-slot:cell(level)="data">
                    <ul>
                      <li v-for="level in data.item.level" :key="level.id">{{ level.name }}</li>
                    </ul>
                  </template>
                  <template v-slot:cell(site)="data">
                    <ul>
                      <li v-for="site in data.item.site" :key="site.id">{{ site.name }}</li>
                    </ul>
                  </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'educationDetail',params:{educationId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"
                           class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showModal" title="Eğitim Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">

            <div class="col-12">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': addSubmitted && $v.addForm.site.$error,
                  }">Site Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="site in sites" :key="site.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`site_${site.id}`"
                        :name="`site_${site.id}`"
                        :value="site.id"
                        v-model="addForm.site"
                        class="form-check-input"
                    />
                    <label :for="`site_${site.id}`" class="form-check-label ms-1">{{ site.name }}</label>
                  </label>

                </div>
                <div
                    v-if="addSubmitted && !$v.addForm.site.required"
                    class="invalid-feedback" style="margin-top:-1px"
                >
                  Site seçimi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': addSubmitted && $v.addForm.level.$error,
                  }">Kur Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="level in level" :key="level.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`level_${level.id}`"
                        :value="level.id"
                        v-model="addForm.level"
                        :disabled="currentUser.role.includes('user')"
                        class="me-1 mt-1"
                        :class="{
            'is-invalid': addSubmitted && $v.addForm.level.$error,
          }"
                    />
                    <label :for="`level_${level.id}`">{{ level.name }}</label>
                  </label>
                </div>
                <div
                    v-if="addSubmitted && !$v.addForm.level.required"
                    class="invalid-feedback" style="margin-top:-5px"
                >
                  Kur seçimi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Eğitim Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Eğitim adı giriniz"
                    :class="{'is-invalid': addSubmitted && $v.addForm.name.$error}"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Eğitim Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Eğitim Başlığı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.title"
                    class="form-control"
                    placeholder="Eğitim başlığı giriniz"
                    :class="{'is-invalid': addSubmitted && $v.addForm.title.$error}"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.title.required"
                    class="invalid-feedback"
                >
                  Eğitim Başlığı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Eğitim Görseli</label>
                <input
                    type="file"
                    id="image"
                    @change="onImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.image.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.image.required"
                    class="invalid-feedback"
                >
                  Resim girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Eğitim Ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="Eğitimi Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': editSubmitted && $v.editForm.site.$error,
                  }">Site Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="site in sites" :key="site.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`site_${site.id}`"
                        :value="site.id"
                        v-model="editForm.site"
                        class="form-check-input"
                    />
                    <label :for="`site_${site.id}`" class="form-check-label ms-1">{{ site.name }}</label>
                  </label>

                </div>
                <div
                    v-if="editSubmitted && !$v.editForm.site.required"
                    class="invalid-feedback" style="margin-top:-1px"
                >
                  Site seçimi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': editSubmitted && $v.editForm.level.$error,
                  }">Kur Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="level in level" :key="level.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`level_${level.id}`"
                        :value="level.id"
                        v-model="editForm.level"
                        :disabled="currentUser.role.includes('user')"
                        class="me-1 mt-1"
                        :class="{
            'is-invalid': editSubmitted && $v.editForm.level.$error,
          }"
                    />
                    <label :for="`level_${level.id}`">{{ level.name }}</label>
                  </label>
                </div>
                <div
                    v-if="editSubmitted && !$v.editForm.level.required"
                    class="invalid-feedback" style="margin-top:-5px"
                >
                  Kur seçimi gerekli bir alandır.
                </div>
              </div>
            </div>


            <div class="col-6">
              <div class="mb-3">
                <label for="name">Eğitim Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Eğitim adı giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.name.$error,
                }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Eğitim Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Eğitim Başlığı</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.title"
                    class="form-control"
                    placeholder="Eğitim başlığı giriniz"
                    :class="{'is-invalid': editSubmitted && $v.editForm.title.$error}"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.title.required"
                    class="invalid-feedback"
                >
                  Eğitim Başlığı girilmesi gerekli bir alandır.
                </div>
              </div>

            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Eğitim Görseli</label>
                <input
                    type="file"
                    id="image"
                    @change="onEditImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.image.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.image.required"
                    class="invalid-feedback"
                >
                  Resim girilmesi gerekli bir alandır.
                </div>

                <!-- Mevcut resmi göstermek için -->
                <div v-if="editForm.image" class="mt-2 text-center">
                  <img :src="editForm.image" alt="Mevcut Resim" style="max-width: 50%; max-height: 100px;"/>
                </div>
              </div>


            </div>
            <div
                v-if="editFormError.length > 0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false">Vazgeç</b-button>
            <b-button type="submit" variant="success" class="ms-1">Eğitim Düzenle</b-button>
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Eğitimi silmek istediğinize emin misiniz? Silinmiş Eğitimi geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Eğitimi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>




